export function pushQueryString(name, value) {
    if(!name || !value) return;
    var qs = new URLSearchParams(window.location.search);
    qs.set(name, value);
    history.pushState({}, document.title, `${window.location.pathname}?${qs.toString()}`);// eslint-disable-line
}

export function pushQueryStrings(str) {
    if(str) {
        history.pushState({}, document.title, `${window.location.pathname}?${str}`); // eslint-disable-line
    } else {
        history.pushState({}, document.title, `${window.location.pathname}`); // eslint-disable-line
    }
}

export function replaceQueryString(name, value) {
    if(!name) return;
    var qs = new URLSearchParams(window.location.search);

    if(value == null) {
        qs.delete(name);
    } else {
        qs.set(name, value);
    }

    if(Array.from(qs).length > 0) {
        history.replaceState({}, document.title, `${window.location.pathname}?${qs.toString()}`);// eslint-disable-line
    } else {
        history.replaceState({}, document.title, window.location.pathname);// eslint-disable-line
    }
}
